import { safeReturnUrl } from '../../shared/routes/safe-return-url';
import { appRoutes } from '../../shared/routes/app-routes';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { HttpParams } from '@angular/common/http';

@Component({
  template: `
    <main class="ss-auth-callback" role="status" aria-live="polite">
      <div class="ss-auth-callback__top">
        <img src="assets/images/logo.svg" alt="SpotPass" class="ss-auth-callback__logo" />
      </div>
      <section class="ss-auth-callback__card">
        <span class="ss-auth-callback__spinner" aria-hidden="true">
          <lucide-icon name="loader-circle" [size]="28"></lucide-icon>
        </span>
        <h1 class="ss-auth-callback__title">Entrando…</h1>
        <p class="ss-auth-callback__subtitle">Preparando sua sessão no painel administrativo.</p>
      </section>
    </main>
  `,
  standalone: false
})
export class AuthComponent implements OnInit {

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const auth: Record<string, string | null> = {};
    const queryParams = this.route.snapshot.fragment || '';
    const params = new HttpParams({ fromString: queryParams });

    params.keys().forEach(key => {
      auth[key] = params.get(key);
    });

    if (auth['access_token']) this.authService.saveTokenData(auth);
    const returnUrl = window.top === window.self ? safeReturnUrl(window.sessionStorage.getItem('returnUrl')) : null;
    if (window.top === window.self) window.sessionStorage.removeItem('returnUrl');
    this.router.navigateByUrl(returnUrl || this.router.createUrlTree(appRoutes.events.list()), { replaceUrl: true });
  }
}
